import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";

const STABLING_ENTRIES_WIDTH = 460;
const NON_SCROLLABLE_ELEMENTS_HEIGHT = 216;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_VIEW = 257;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_SMALL_MOBILE_VIEW = 250;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_POPUP_VIEW = 221;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_SMALL_MOBILE_POPUP_VIEW = 192;

const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_PREVIEW_SECTION = 271;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_TABLET_PREVIEW_SECTION = 317;

export default makeStyles((theme: MuiTheme) => ({
  root: {
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      borderLeft: `1px solid ${theme.palette.divider}`
    }
  },
  pageHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 18,
    paddingTop: 10,
    paddingLeft: 8,
    paddingRight: 8,
    maxHeight: 40,
    boxShadow: "none",
    borderBottom: "none",
    borderLeft: "none",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      maxHeight: 76,
      height: 76,
      flexDirection: "column",
      justifyContent: "start",
      top: 0
    },
    [theme.breakpoints.up("md")]: {
      maxHeight: 64,
      height: 64,
      padding: "8px 8px 8px 24px",
      borderBottom: `1px solid ${theme.palette.divider}`
    }
  },
  pageContent: {
    backgroundColor: theme.palette.common.white
  },
  pageFooter: {
    position: "sticky",
    bottom: 0,
    display: "flex",
    backgroundColor: theme.palette.common.white,
    flexWrap: "wrap",
    gap: 15,
    alignItems: "center",
    justifyContent: "right",
    padding: 16,
    borderTop: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up("md")]: {
      minHeight: 88,
      maxHeight: 88,
      paddingLeft: 24,
      paddingRight: 24,
      justifyContent: "space-between"
    }
  },
  pageFooterButton: {
    height: 42,
    maxWidth: 164,
    flex: 1,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      maxWidth: "50%"
    }
  },
  pageFooterButtonNext: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: "#5db491"
    }
  },
  tabsRoot: {
    maxWidth: "100%",
    backgroundColor: "#f6f6f6",
    display: "flex",
    flexDirection: "column",
    flex: 1
  },
  tabs: {
    position: "sticky",
    top: 104,
    zIndex: theme.zIndex.page.header,
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      top: 76
    },
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  tabsContent: {
    display: "flex",
    flex: 1
  },
  tabsViews: {
    "& .react-swipeable-view-container": {
      display: "flex",
      flex: 1,
      height: "100%",
      "& > div": {
        flex: "auto"
      }
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flex: 1,
      "& div[aria-hidden='true']": {
        display: "block",
        height: "auto"
      }
    }
  },
  tabSlide: {
    display: "flex",
    maxHeight: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_SMALL_MOBILE_VIEW}px)`,
    "&.popupView": {
      maxHeight: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_SMALL_MOBILE_POPUP_VIEW}px)`
    },
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      maxHeight: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_VIEW}px)`,
      "&.popupView": {
        maxHeight: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_POPUP_VIEW}px)`
      }
    },
    [theme.breakpoints.up(Breakpoints.MD_960)]: {
      maxHeight: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT}px)`,
      "&:first-child": {
        maxWidth: `calc(100% - ${STABLING_ENTRIES_WIDTH}px)`
      },
      "&:last-child": {
        display: "flex",
        height: "auto",
        background: theme.palette.common.white
      }
    }
  },
  tab: {
    height: 42,
    fontSize: 14,
    textTransform: "uppercase",
    "&$tabSelected": {
      color: theme.palette.secondary.dark
    }
  },
  tabSelected: {},
  tabsIndicator: {
    backgroundColor: theme.palette.secondary.dark
  },
  form: {
    width: "100%"
  },
  sectionValidIcon: {
    width: 17,
    height: 17,
    marginBottom: 2
  },
  valid: {
    color: "#489B77"
  },
  invalid: {
    color: theme.palette.error.main
  },
  tncCheckbox: {
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    "& .MuiSvgIcon-root": {
      fontSize: 40,
      strokeWidth: "1.5px",
      stroke: theme.palette.common.white
    }
  },
  tncCheckboxChecked: {
    color: theme.palette.common.white,
    "& .MuiSvgIcon-root": {
      color: "rgba(72, 155, 119, 1)",
      stroke: "transparent"
    }
  },
  stablingEntries: {
    display: "flex",
    flex: 1,
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "column",
      minWidth: STABLING_ENTRIES_WIDTH,
      maxWidth: STABLING_ENTRIES_WIDTH,
      height: "100%",
      borderLeft: `1px solid ${theme.palette.divider}`
    }
  },
  pageFooterDesktopButtons: {
    display: "flex",
    gap: 20,
    flex: 1,
    justifyContent: "right"
  },
  pauseAndCloseButton: {
    width: 164
  },
  termsLink: {
    color: theme.palette.secondary.dark
  },
  scrollablePreviewContainer: {
    maxHeight: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_PREVIEW_SECTION}px)`,
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      maxHeight: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_TABLET_PREVIEW_SECTION}px)`
    },
    [theme.breakpoints.down("sx")]: {
      maxHeight: "100%"
    }
  }
}));
